import { render, staticRenderFns } from "./QuestionsAnswersModule.vue?vue&type=template&id=5f4b23a0&scoped=true&"
import script from "./QuestionsAnswersModule.vue?vue&type=script&lang=js&"
export * from "./QuestionsAnswersModule.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAnswersModule.vue?vue&type=style&index=0&id=5f4b23a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b23a0",
  null
  
)

export default component.exports